    const inlineMenu = document.querySelector(".header__inline-menu");
    const detailsItems = inlineMenu.querySelectorAll("details");

    detailsItems.forEach(item => {
      const ulElement = item.querySelector("ul");
      item.addEventListener("mouseover", () => {
        item.setAttribute("open", true);
        ulElement.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
        item.addEventListener("mouseleave", () => {
          item.removeAttribute("open");
        });
      });
    });

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product .product__title h1').forEach(el => {
    el.innerHTML = el.innerHTML
      .replace(/- (Monthly|Annual)/g, '<span>$1</span>');
    el.style.visibility = 'visible';
  });
});